<template lang="html">
  <section class="hero is-light is-fullheight">
    <div class="hero-head">
        <img src="~@/assets/img/Logo.svg">
    </div>

    <div class="hero-body">
      <div class="container">
        <h1 class="title">
          We build audio experiences.
        </h1>
        <h2 class="subtitle">
        </h2>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'home'
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue